module.exports = __webpack_public_path__ + "img/tab_sound_select_icon.7fbd063b.svg";